import React from "react";

import { SDUIComponentRenderer } from "../../__internal__/SDUIComponentRenderer/SDUIComponentRenderer";
import {
  SDUISectionInstanceRendererProps,
  SectionLoggingEventParams,
} from "../../__internal__/types";

import { SDUIRotatingSectionComponentRenderer } from "./SDUIRotatingSectionComponentRenderer";
import {
  heightAdjustedComponentContainer,
  hiddenContainerForHeightAdjustment,
} from "./styles/SDUIRotatingSectionRenderer.css";

export const SDUIRotatingSectionRenderer: React.FC<
  SDUISectionInstanceRendererProps
> = ({ section, componentRenderers, loadTimingRef }) => {
  const rotatingSection = section.rotating_section;

  if (!rotatingSection) {
    return null;
  }

  return (
    <div className={heightAdjustedComponentContainer}>
      {rotatingSection.components.map((component) => (
        <div key={component.id} className={hiddenContainerForHeightAdjustment}>
          <SDUIComponentRenderer
            isPrimaryContent
            key={component.id}
            component={component}
            componentRenderers={componentRenderers}
            // We don't want to have any logging in this section
            // Since it isn't shown to the user
            sectionLoggingParams={SectionLoggingEventParams.build()}
          />
        </div>
      ))}
      <SDUIRotatingSectionComponentRenderer
        section={section}
        componentRenderers={componentRenderers}
        loadTimingRef={loadTimingRef}
        sectionLoggingData={SectionLoggingEventParams.build()}
      />
    </div>
  );
};
